module.exports = __webpack_public_path__ + "img/ios_model_area_100.b58a3089.png";